import Vue from 'vue'
import App from './App.vue'
import VueMaterial from 'vue-material'
import Vuelidate from 'vuelidate'
import Moment from 'moment'
import VueResource from 'vue-resource'

// Style
import 'vue-material/dist/vue-material.min.css'

Vue.config.productionTip = true;

window.endpoint = {
    check: 'https://cors-anywhere.herokuapp.com/https://www.assidai.it/wp-json/landing/v1/check',
    send: 'https://cors-anywhere.herokuapp.com/https://www.assidai.it/wp-json/landing/v1/send',
    mail: 'https://cors-anywhere.herokuapp.com/http://104.248.101.247/iadissa/'
};

Vue.use(VueMaterial);
Vue.use(Vuelidate);
Vue.use(Moment);
Vue.use(VueResource);

new Vue({
  render: h => h(App),
}).$mount('#app');
